/**
 * HLF Collection Product Card - Section JavaScript
 * Handles Slider Engine, Wishlist, and Add to Cart interactions
 */
(function () {
  'use strict';

  function initAllSections() {
    document.querySelectorAll('.hlf-section[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.hlf-section[data-section-id]') || e.target;
    if (section && section.dataset && section.dataset.sectionId) {
      initSection(section);
    }
  });

  function initSection(section) {
    if (section._hlfInitialized) return;
    section._hlfInitialized = true;

    const container = section.querySelector('.hlf-products-container');
    const inner = section.querySelector('.hlf-products-inner');
    if (!container || !inner) return;

    function getActiveLayout() {
      const isMobile = window.innerWidth <= 640;
      return isMobile ? (container.dataset.layoutMobile || 'grid') : (container.dataset.layoutDesktop || 'grid');
    }

    function syncLayout() {
      const layout = getActiveLayout();
      if (layout === 'slider') {
        if (!container._hlfSliderApi) {
          container._hlfSliderApi = initSlider(container, inner, section);
        }
      } else {
        if (container._hlfSliderApi) {
          container._hlfSliderApi.destroy();
          container._hlfSliderApi = null;
        }
      }
    }

    let resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncLayout, 100);
    });

    syncLayout();

    /* ============================================================
       WISHLIST TOGGLE
    ============================================================ */
    section.addEventListener('click', function (e) {
      const wishBtn = e.target.closest('[data-wishlist-btn]');
      if (!wishBtn) return;
      e.preventDefault();
      wishBtn.classList.toggle('is-wishlisted');
      const productId = wishBtn.dataset.productId;
      document.dispatchEvent(new CustomEvent('hlf:wishlist:toggle', {
        detail: { productId, isWishlisted: wishBtn.classList.contains('is-wishlisted') }
      }));
    });

    /* ============================================================
       ADD TO CART
    ============================================================ */
    section.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      const config = (typeof fetchConfig === 'function')
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          };

      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((s) => s.id)
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(btn);
        }
      }
      config.body = formData;

      const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

      fetch(cartAddUrl, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Cart Error:', response.description);
            return;
          }

          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: response,
            });
          }

          if (typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          }

          const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
          fetch(`${cartUrl}.js`)
            .then((res) => res.json())
            .then((cartData) => {
              document.dispatchEvent(new CustomEvent('cart:update', {
                detail: { data: { itemCount: cartData.item_count } }
              }));
            })
            .catch(() => {});

          const originalText = btn.querySelector('.hlf-btn-text');
          if (originalText) {
            const orig = originalText.textContent;
            originalText.textContent = '✓ Added!';
            setTimeout(() => { originalText.textContent = orig; }, 1800);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        });
    });
  }

  /* ============================================================
     SLIDER ENGINE
  ============================================================ */
  function initSlider(container, track, section) {
    const prevBtn = container.querySelector('.hlf-slider-arrow--prev');
    const nextBtn = container.querySelector('.hlf-slider-arrow--next');
    const navContainer = container.querySelector('.hlf-slider-nav');
    const autoplay = container.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 3000;
    const loop = container.dataset.loop === 'true';

    let currentIndex = 0;
    let autoplayInterval = null;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let startTranslate = 0;

    const cards = track.querySelectorAll('.hlf-product-card');
    const totalCards = cards.length;
    if (totalCards <= 1) return { destroy: () => {} };

    function getGap() {
      const isMobile = window.innerWidth <= 640;
      const val = getComputedStyle(section).getPropertyValue(isMobile ? '--hlf-card-gap-mobile' : '--hlf-card-gap-desktop');
      return parseInt(val, 10) || (isMobile ? 10 : 16);
    }

    function getSlideWidth() {
      if (!cards.length) return 0;
      const gap = getGap();
      const cw = cards[0].getBoundingClientRect().width;
      return cw + gap;
    }

    function getWholeVisibleCount() {
      const sw = getSlideWidth();
      if (sw <= 0) return 1;
      const gap = getGap();
      return Math.max(1, Math.floor((container.offsetWidth + gap) / sw));
    }

    function getMaxIndex() {
      return Math.max(0, totalCards - getWholeVisibleCount());
    }

    function goTo(index, animate = true) {
      const max = getMaxIndex();
      if (!loop) {
        index = Math.max(0, Math.min(index, max));
      } else {
        if (index < 0) index = max;
        if (index > max) index = 0;
      }
      currentIndex = index;
      const offset = currentIndex * getSlideWidth();
      track.style.transition = animate ? 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = `translateX(-${offset}px)`;
      updateArrows();
      updateDots();
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      const max = getMaxIndex();
      if (!loop) {
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex >= max;
      } else {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
      }
    }

    function buildDots() {
      if (!navContainer) return;
      navContainer.innerHTML = '';
      const max = getMaxIndex();
      if (max <= 0) return;
      for (let i = 0; i <= max; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hlf-slider-nav__dot' + (i === currentIndex ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => goTo(i));
        navContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!navContainer) return;
      navContainer.querySelectorAll('.hlf-slider-nav__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    // Touch / Drag events
    function dragStart(e) {
      isDragging = true;
      startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      startTranslate = currentIndex * getSlideWidth();
      track.style.transition = 'none';
    }

    function dragMove(e) {
      if (!isDragging) return;
      const x = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      const diff = startX - x;
      currentTranslate = startTranslate + diff;
      track.style.transform = `translateX(-${currentTranslate}px)`;
      if (e.type === 'touchmove' && Math.abs(diff) > 10 && e.cancelable) {
        e.preventDefault();
      }
    }

    function dragEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      const x = e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX;
      const diff = startX - x;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      } else {
        goTo(currentIndex);
      }
    }

    track.addEventListener('mousedown', dragStart);
    track.addEventListener('touchstart', dragStart, { passive: true });
    window.addEventListener('mouseup', dragEnd);
    window.addEventListener('touchend', dragEnd);
    track.addEventListener('mousemove', dragMove);
    track.addEventListener('touchmove', dragMove, { passive: false });

    function handlePrev() {
      goTo(currentIndex - 1);
      resetAutoplay();
    }

    function handleNext() {
      goTo(currentIndex + 1);
      resetAutoplay();
    }

    if (prevBtn) prevBtn.addEventListener('click', handlePrev);
    if (nextBtn) nextBtn.addEventListener('click', handleNext);

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayInterval = setInterval(() => goTo(currentIndex + 1), autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('mouseleave', startAutoplay);

    function onResize() {
      goTo(Math.min(currentIndex, getMaxIndex()), false);
      buildDots();
      updateArrows();
    }

    window.addEventListener('resize', onResize);

    buildDots();
    updateArrows();
    startAutoplay();

    return {
      destroy() {
        stopAutoplay();
        track.removeEventListener('mousedown', dragStart);
        track.removeEventListener('touchstart', dragStart);
        window.removeEventListener('mouseup', dragEnd);
        window.removeEventListener('touchend', dragEnd);
        track.removeEventListener('mousemove', dragMove);
        track.removeEventListener('touchmove', dragMove);
        if (prevBtn) prevBtn.removeEventListener('click', handlePrev);
        if (nextBtn) nextBtn.removeEventListener('click', handleNext);
        container.removeEventListener('mouseenter', stopAutoplay);
        container.removeEventListener('mouseleave', startAutoplay);
        window.removeEventListener('resize', onResize);
        track.style.transform = '';
        track.style.transition = '';
      }
    };
  }
})();
